import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const getOneShippingInfo = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/shippinginfo/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Failed to fetch shipping info");
      throw err;
    });
};

export const createShippingInfo = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/shippinginfo`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateShippingInfo = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/shippinginfo/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteShippingInfo = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/shippinginfo/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const viewShippingInfoReport = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/shippinginfo/${id}/report`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};